<template>
  <v-card v-if="visible" class="mb-4 checklist-card" outlined>
    <v-card-text class="pa-6">
      <div class="badge-pill">
        <app-icon small color="#F0B429">star</app-icon>
        <span class="ml-2">Primeiros passos para ativar sua clínica</span>
      </div>

      <h2 class="mt-4 primary--text">Ative sua clínica</h2>

      <p class="mt-2 mb-4">
        Complete os passos abaixo para aproveitar todos os recursos do
        Psicoplanner.
      </p>

      <v-row dense>
        <v-col cols="12" sm="4" v-for="item in items" :key="item.label">
          <div
            class="checklist-item pa-3 d-flex align-center"
            :class="{ 'checklist-item--clickable': !item.done }"
            @click="open(item)"
          >
            <v-avatar size="38" :color="item.done ? '#E4F6EE' : '#EDE7FB'">
              <app-icon :color="item.done ? 'success' : 'primary'" small>
                {{ item.done ? 'done' : item.icon }}
              </app-icon>
            </v-avatar>
            <span
              class="ml-3 font-weight-medium"
              :class="{ 'text-decoration-line-through': item.done }"
            >
              {{ item.label }}
            </span>
            <v-spacer />
            <v-chip
              v-if="!item.done"
              x-small
              color="orange lighten-5"
              text-color="orange darken-2"
            >
              Pendente
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { checklistItems } from "@/components/dashboard/data/checklistItems";
import { withinOnboardingWindow } from "@/utils/onboardingWindow";

export default {
  computed: {
    company() {
      return this.$store.state.auth.company;
    },

    items() {
      return checklistItems(this.$store.state.onboarding);
    },

    visible() {
      const hasPending = this.items.some((item) => !item.done);

      return hasPending && withinOnboardingWindow(this.company, 7);
    },
  },

  methods: {
    open(item) {
      if (item.done) {
        return;
      }

      this.$router.push(item.route);
    },
  },
};
</script>

<style scoped>
.checklist-card {
  border-radius: 20px !important;
  border-color: #ece7f8 !important;
  background: linear-gradient(135deg, #fbfaff 0%, #f3effd 100%);
}

.badge-pill {
  display: inline-flex;
  align-items: center;
  background: #fff;
  border: 1px solid #eae4f7;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: #6e5aae;
}

.checklist-item {
  background: #fff;
  border: 1px solid #eee8f9;
  border-radius: 12px;
}

.checklist-item--clickable {
  cursor: pointer;
}

.checklist-item--clickable:hover {
  border-color: #d9cef6;
}
</style>
